import { updateEmail, updatePassword } from "firebase/auth";
import { doc, getDoc, updateDoc, setDoc } from "firebase/firestore";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { createProperty } from "./property";
const { db, auth, storage } = require("../firebase");

export const createProfile = async (data) => {
  const { password, confirm_password, ...rest } = data.values;
  const { profilePicture, ...therest } = rest;
  const createdAt = new Date();
  const updatedAt = new Date();
  const profileRef = doc(db, `users/${data.user.uid}/profile`, "userProfile");
  try {
    await setDoc(profileRef, {
      ...therest,
      createdAt,
      updatedAt,
    });
    // handle profile picture upload
    if (profilePicture) {
      const imageRef = ref(storage, `/profile/${data.user.uid}`);
      uploadBytes(imageRef, profilePicture).then((snapshot) => {
        getDownloadURL(snapshot.ref).then(async (url) => {
          await updateDoc(profileRef, {
            profilePicture: url,
          });
        });
      });
    }
  } catch (e) {
    console.error("Error adding document: ", e);
  }
};

export const updateProfile = async (data, mediaURLs) => {
  const updatedAt = new Date();
  const profileRef = doc(db, `users/${auth.currentUser.uid}/profile`, "userProfile");
  const { address, city, state, zipCode, country, ...rest } = data;
  await updateDoc(profileRef, { address, city, zipCode, state, country, updatedAt });
  await createProperty(rest, mediaURLs);
  await updateDoc(doc(db, "users", auth.currentUser.uid), { isProfileCompleted: true, updatedAt: new Date() });
  return "success";
};

export const editProfile = async (data, setIsPictureUpdated) => {
  const updatedAt = new Date();
  const profileRef = doc(db, `users/${auth.currentUser.uid}/profile`, "userProfile");
  const { password, ...rest } = data;

  if (data?.email !== auth?.currentUser?.email) {
    await updateEmail(auth.currentUser, data?.email);
  }
  if (setIsPictureUpdated) {
    const imageRef = ref(storage, `/profile/${auth.currentUser.uid}`);
    await uploadBytes(imageRef, data?.profilePicture).then((snapshot) => {
      getDownloadURL(snapshot.ref).then(async (url) => {
        await updateDoc(profileRef, {
          ...rest,
          profilePicture: url,
          updatedAt,
        });
      });
    });
  } else {
    await updateDoc(profileRef, {
      ...rest,
      updatedAt,
    });
  }
  if (!auth.currentUser.isProfileCompleted) {
    await updateDoc(doc(db, "users", auth.currentUser.uid), { isProfileCompleted: true, updatedAt });
  }

  if (password) {
    await updatePassword(auth.currentUser, password);
  }
  return "success";
};

export const getProfile = async () => {
  const profileRef = doc(db, `users/${auth.currentUser.uid}/profile`, "userProfile");
  await getDoc(profileRef);
  const profile = await getDoc(profileRef);
  if (profile.exists()) {
    return { profile: profile.data() };
  }
};
